export default {
    addSessionDetails (state, payload) {
        state.sessionDetails = payload;
    },
    addSessionToken (state, payload) {
        let token = JSON.parse(JSON.stringify(payload));
        state.sessionToken = token;
    },
    //template mutations
    addTemplateData (state, payload) {
        let templateSettings = JSON.parse(JSON.stringify(payload))
        state.templateFormat = {...templateSettings};
    },
    //project mutations
    addProjectData (state, payload) {
        let projectSettings = JSON.parse(JSON.stringify(payload))
        state.project = {
            ...state.project,
            ...projectSettings
        }
    },
    addGalleryElement (state, payload) {
        let galleryElement = JSON.parse(JSON.stringify(payload))
        state.gallery = [...state.gallery, galleryElement]
    },
    removeGalleryElement (state, payload) {
        let galleryElement = payload

        state.gallery.splice(galleryElement, 1);
    },
    //page mutations
    addNewPage (state, payload) {
        let pageElement = JSON.parse(JSON.stringify(payload))
        state.project.pages.map(page => {
            page.content.isActive = false;
        });
        // state.project.pages = [...state.project.pages, pageElement]
        state.project.pages.push(pageElement);
        let index = state.project.pages.findIndex(page => page.content.id === pageElement.content.id);
        state.currentPage  = pageElement.content.id
        state.currentPageIndex  = index
    },
    removePage (state, payload) {
        const pageId = payload;

        state.project.pages = state.project.pages.filter(page => page.content.id !== pageId);
        state.currentPageIndex = 0
        // let pageIndex = payload
        // if (state.project.pages[pageIndex].elements !== undefined) {
        //     state.project.pages[pageIndex].elements.forEach(el => {
        //         el.isActive = false;
        //     })
        // }

        // state.project.pages[pageIndex].elements = [];
        // state.project.pages.splice(pageIndex, 1);
        // state.currentPageIndex = 0
        // state.project.pages[state.currentPageIndex].isActive = true;
    },
    setCurrentPage(state, payload) {
        state.currentPage = payload;
        state.project.pages.forEach(page => {
            page.content.isActive = false;
        });
        state.project.pages.find(page => page.content.id === payload).content.isActive = true;
    },
    slidePage (state, payload) {
        let data = JSON.parse(JSON.stringify(payload));
        let index = data.pageIndex;
        let direction = data.direction;

        state.project.pages.forEach(page => {
            page.content.isActive = false;
        });

        if (direction === 'prev') {
            Object.assign(state.project.pages[index - 1].content, { isActive: true })

            state.currentPage  = state.project.pages[index - 1].content.id
            state.currentPageIndex  = index - 1
        } else {
            Object.assign(state.project.pages[index + 1].content, { isActive: true })

            state.currentPage  = state.project.pages[index + 1].content.id
            state.currentPageIndex  = index + 1
        }
    },
    savePageWebSize (state, payload) {
        state.webPageSize = payload;
    },
    savePageSize (state, payload) {
        state.pageSize = payload;
    },
    clearPage (state) {
        const activePage = state.project.pages.find(page => page.content.isActive === true);
        activePage.content.elements = [];
    },
    setPageColor (state, payload) {
        // let color =  JSON.parse(JSON.stringify(payload));
        // let activePageColor = state.project.pages.find(page => page.content.isActive === true).content.pageColor;
        const activePage = state.project.pages.find(page => page.content.isActive === true);

        activePage.content.pageColor.rgb = payload.rgb;
        activePage.content.pageColor.hex = payload.hex;
        activePage.content.pageColor.X = payload.X;
        activePage.content.pageColor.Y = payload.Y;
    },
    setPageRadius (state, payload) {
        const activePage = state.project.pages.find(page => page.content.isActive === true);
        activePage.content.pageRadius = payload;
    },
    lockPage (state, payload) {
        const activePage = state.project.pages.find(page => page.content.isActive === true);
        activePage.content.isLocked = payload;
    },
    setPageBackground (state, payload) {
        const activePage = state.project.pages.find(page => page.content.isActive === true);
        activePage.content.backgroundImage = {
            ...payload
        }
        // activePage.content.backgroundImage[payload.option] = payload.value;
    },
    removePageBackground (state) {
        const activePage = state.project.pages.find(page => page.content.isActive === true);
        activePage.content.backgroundImage = {
            url: null,
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat'
        };
    },
    //element mutations
    addPageElement (state, payload) {
        const data = JSON.parse(JSON.stringify(payload));

        let element;

        if (data.elementFromPage !== undefined) {
            element = data.elData;
        } else {
            element = data.fromProject ? data.elData : data;
        }
        const fromProject = data.fromProject ? true : false;
        // const pageId = data.elementFromPage ? state.currentPage : element.pageId;

        const pageId = element.pageId;
        let pageIndex;

        if (state.sessionDetails.mode === 'merchant') {
            // pageIndex = state.project.pages.findIndex(page => page.content.id === pageId);
            if (data.elementFromPage) {
                pageIndex = state.project.pages.findIndex(page => page.content.isActive === true)
            } else {
                pageIndex = state.project.pages.findIndex(page => page.content.id === pageId);
            }
        } else {
            if (data.elementFromPage) {
                pageIndex = state.project.pages.findIndex(page => page.content.isActive === true)
            } else {
                pageIndex = state.project.pages.findIndex(page => page.content.id === pageId);
            }
        }
        // const pageIndex = state.sessionDetails.mode === 'merchant' ? state.project.pages.findIndex(page => page.content.id === pageId) : state.project.pages.findIndex(page => page.content.isActive === true)
        // const pageIndex = state.project.pages.findIndex(page => page.content.id === pageId);
        // const pageIndex = state.project.pages.findIndex(page => page.content.isActive === true);


        fromProject ? (
            element = {
                ...element,
                fromProject: true
            },
            state.project.pages[pageIndex].content.elements.push(element)
        ) : (
            state.project.pages[pageIndex].content.zIndex = state.project.pages[pageIndex].content.zIndex + 1,
            state.project.pages[pageIndex].content.elements.length !== 0 ? (
                state.project.pages[pageIndex].content.elements.forEach(element => {
                    element.isActive = false;
                }),
    
                state.project.pages[pageIndex].content.elements.push(element)
            ) : (state.project.pages[pageIndex].content.elements.push(element))
        );
        
        
    },
    lockPageElement (state, payload) {
        let activePageElements = state.project.pages[state.currentPageIndex].content.elements;
        let activeElementIndex = activePageElements.findIndex(element => element.isActive);

        activePageElements[activeElementIndex].isLocked = payload;
        state.activeElement.isLocked = payload;
    },
    removePageElement (state) {
        const activePageElements = state.project.pages.find(page => page.content.isActive === true).content.elements;
        let activeElementIndex = activePageElements.findIndex(element => element.isActive);
        let elementsArrLength = activePageElements.length;

        activePageElements.slice(activeElementIndex).map(el => el.zIndex = el.zIndex - 1);

        if (elementsArrLength === 1 && activeElementIndex === 0) {
            state.project.pages.find(page => page.content.isActive === true).content.elements = [];
            state.activeElement = {};
            
        }

        if (elementsArrLength > 1 && activeElementIndex === 0) {
            activePageElements.splice(0, 1);
            activePageElements[0].isActive = true;
            state.activeElement = activePageElements[0];
            
        }

        if (elementsArrLength > 1 && activeElementIndex > 0) {
            activePageElements[activeElementIndex - 1].isActive = true;
            activePageElements.splice(activeElementIndex, 1);
            state.activeElement = activePageElements[activeElementIndex - 1];
            
        }
    },
    toggleElements (state) {
        state.elementsVisible = !state.elementsVisible;
    },
    addMoveableElement (state, payload) {
        let element = JSON.parse(JSON.stringify(payload))

        state.moveableElements.push(element);
    },
    activateElement (state, payload) {
        let elementCurrent =  JSON.parse(JSON.stringify(payload))

        // let activePageElements = state.project.pages[state.currentPageIndex].content.elements;
        let activePageElements = state.project.pages.find(page => page.content.isActive === true).content.elements;
        let elementIndex = activePageElements.findIndex(element => element.id === elementCurrent.id);

        activePageElements.forEach(el => {
            el.isActive = false
        })

        activePageElements[elementIndex].isActive = true
    },
    disableElementsOnPage (state) {
        // let activePageElements = state.project.pages[state.currentPageIndex].content.elements;
        let activePageElements = state.project.pages.find(page => page.content.isActive === true).content.elements;
        let photocells = state.project.pages.find(page => page.content.isActive === true).content.elements.filter(el => el.type === 'PHOTO_CELL_ELEMENT');
        // let photocells = state.project.pages[state.currentPageIndex].content.elements.filter(el => el.type === 'PHOTO_CELL_ELEMENT');

        photocells.forEach(photocell => {
            photocell.photoCellImageIsEdited = false;
        })

        activePageElements === undefined ? false : activePageElements.forEach(el => {
            el.isActive = false;
        })
        state.activeElement = {}
    },
    editImageElementFilter (state, payload) {
        let filter =  JSON.parse(JSON.stringify(payload))

        let activePageElements = state.project.pages[state.currentPageIndex].content.elements;
        let activeElementIndex = activePageElements.findIndex(element => element.isActive);

        activePageElements[activeElementIndex].filters[filter.filterName].value = Number(filter.filterValue);
    },
    openGalleryModal (state, payload) {
        if (payload === 'galleryModal') {
            state.galleryModalOpen = true
        }   
    },
    closeModal (state, payload) {
        if (payload === 'galleryModal') {
            state.galleryModalOpen = false
        }
    },
    elementColor (state, payload) {
        let color =  JSON.parse(JSON.stringify(payload));

        let activePageElements = state.project.pages.find(page => page.content.isActive === true).content.elements;
        let activeElementIndex = activePageElements.findIndex(element => element.isActive);

        if (activePageElements[activeElementIndex].type === 'PHOTO_CELL_ELEMENT') {
            activePageElements[activeElementIndex].maskImg.color.rgb = color.rgb;
            activePageElements[activeElementIndex].maskImg.color.hex = color.hex;
            activePageElements[activeElementIndex].maskImg.color.X = color.X;
            activePageElements[activeElementIndex].maskImg.color.Y = color.Y;

            state.activeElement.maskImg.color.rgb = color.rgb;
            state.activeElement.maskImg.color.hex = color.hex;
            state.activeElement.maskImg.color.X = color.X;
            state.activeElement.maskImg.color.Y = color.Y;
        } else {
            activePageElements[activeElementIndex].color.rgb = color.rgb;
            activePageElements[activeElementIndex].color.hex = color.hex;
            activePageElements[activeElementIndex].color.X = color.X;
            activePageElements[activeElementIndex].color.Y = color.Y;

            state.activeElement.color.rgb = color.rgb;
            state.activeElement.color.hex = color.hex;
            state.activeElement.color.X = color.X;
            state.activeElement.color.Y = color.Y;
        }
    },
    qrElementColor (state, payload) {
        let color =  payload.color;
        let side = payload.side;

        let activePageElements = state.project.pages.find(page => page.content.isActive === true).content.elements;
        let activeElementIndex = activePageElements.findIndex(element => element.isActive);

        activePageElements[activeElementIndex][side].rgb = color.rgb;
        activePageElements[activeElementIndex][side].hex = color.hex;
        activePageElements[activeElementIndex][side].X = color.X;
        activePageElements[activeElementIndex][side].Y = color.Y;

        state.activeElement[side].rgb = color.rgb;
        state.activeElement[side].hex = color.hex;
        state.activeElement[side].X = color.X;
        state.activeElement[side].Y = color.Y;
    },
    addColorToLastUsed (state, payload) {
        const lastUsedColors = state.lastUsedColors;

        if (lastUsedColors.length < 5) {
            state.lastUsedColors.push(payload);
        } else {
            state.lastUsedColors.pop();
            state.lastUsedColors.unshift(payload);
        }
    },
    setTextVariable (state, payload) {
        let textVariable = JSON.parse(JSON.stringify(payload));

        // let activePageElements = state.project.pages[state.currentPageIndex].content.elements;
        let activePageElements = state.project.pages.find(page => page.content.isActive === true).content.elements;
        let activeElementIndex = activePageElements.findIndex(element => element.isActive);

        if (activeElementIndex > -1) {
            activePageElements[activeElementIndex].font[textVariable.variableName] = textVariable.value;
            state.activeElement.font[textVariable.variableName] = textVariable.value;

            if(textVariable.variableName === 'family') {
                activePageElements[activeElementIndex].font.weight.name = 'Regular';
                activePageElements[activeElementIndex].font.weight.style = 'normal';
                activePageElements[activeElementIndex].font.weight.value = 400;
            }
        }
        
    },
    setTextPlaceholder (state, payload) {
        let activePageElements = state.project.pages.find(page => page.content.isActive === true).content.elements;
        let activeElementIndex = activePageElements.findIndex(element => element.isActive);

        if (payload.placeholderId === 'noPlaceholder') {
            activePageElements[activeElementIndex].placeholder = {
                hasPlaceholder: false,
                placeholderId: 'noPlaceholder',
                placeholderSystemName: 'noPlaceholder',
                placeholderName: 'noPlaceholder'
            };
            state.activeElement.placeholder = {
                hasPlaceholder: false,
                placeholderId: 'noPlaceholder',
                placeholderSystemName: 'noPlaceholder',
                placeholderName: 'noPlaceholder'
            };
        } else {
            activePageElements[activeElementIndex].placeholder = {
                hasPlaceholder: true,
                placeholderId: payload.placeholderId,
                placeholderSystemName: payload.placeholderSystemName,
                placeholderName: payload.placeholderName
            };
            state.activeElement.placeholder = {
                hasPlaceholder: true,
                placeholderId: payload.placeholderId,
                placeholderSystemName: payload.placeholderSystemName,
                placeholderName: payload.placeholderName
            };
        }
    },
    setPlaceholders(state, payload) {
        state.placeholders = payload;
    },
    setPlaceholderUserInputs(state, payload) {
        state.placeholderUserInputs = payload;
    },
    setPlaceholderContent(state, payload) {
        const placeholder = state.placeholderUserInputs.find(pl => pl.placeholderObj.placeholderId === payload.id);
        // placeholder.content = payload.content;

        const hasContent = Object.keys(payload).includes('content');
        const hasError = Object.keys(payload).includes('hasError');
        const harErrorMessage = Object.keys(payload).includes('errorMessage');

        if (hasContent) {
            placeholder.content = payload.content;
        }
        if (hasError) {
            placeholder.hasError = payload.hasError;
        }
        if (harErrorMessage) {
            placeholder.errorMessage = payload.errorMessage;
        }
    },
    changeText (state, payload) {
        let data = JSON.parse(JSON.stringify(payload));

        if (!data.contentFromPlaceholder) {
            const activePageElements = state.project.pages.find(page => page.content.isActive === true).content.elements;
            const activeElementIndex = activePageElements.findIndex(element => element.id === data.id);

            activePageElements[activeElementIndex].content = data.content;
        } else {
            const pageWithElement = state.project.pages.find(page => page.content.elements.some(el => el.id === data.id)).content.elements;
            const elementToChange = pageWithElement.find(el => el.id === data.id);
            elementToChange.content = data.content;
        }
        
    },
    changeTab (state, payload) {
        let tab = JSON.parse(JSON.stringify(payload));

        state.currentTab = tab;
    },
    changeActiveElement (state, payload) {
        let activeElement = JSON.parse(JSON.stringify(payload));
        state.activeElement = activeElement;
    },
    updateElement (state, payload) {
        let dataToChange = JSON.parse(JSON.stringify(payload));

        // let activePageElements = state.project.pages[state.currentPageIndex].content.elements;
        let activePageElements = state.project.pages.find(page => page.content.isActive === true).content.elements;
        let activeElementIndex = activePageElements.findIndex(element => element.isActive);
        
        Object.keys(dataToChange).forEach(function (item) {
            if (activeElementIndex !== -1) {
                activePageElements[activeElementIndex][item] = dataToChange[item];
            }
            if (Object.keys(state.activeElement).length !== 0) {
                state.activeElement[item] = dataToChange[item];
            }
        });
    },
    updateThisElement(state, payload) {
        let dataToChange = payload.values;

        const elementToChange = state.project.pages.find(page => page.content.id === payload.pageId).content.elements.find(el => el.id === payload.id);
        Object.keys(dataToChange).forEach(function (item) {
            elementToChange[item] = dataToChange[item];
        });

    },
    flipElement (state, payload) {
        // let activePageElements = state.project.pages[state.currentPageIndex].content.elements;
        let activePageElements = state.project.pages.find(page => page.content.isActive === true).content.elements;
        let activeElementIndex = activePageElements.findIndex(element => element.isActive);

        if (payload === 'to-front') {
            if (activeElementIndex < activePageElements.length -1) {
                activePageElements[activeElementIndex].zIndex = activePageElements[activeElementIndex].zIndex + 1
                activePageElements[activeElementIndex + 1].zIndex = activePageElements[activeElementIndex + 1].zIndex - 1
            }
        } else {
            if (activeElementIndex !== 0) {
                activePageElements[activeElementIndex].zIndex = activePageElements[activeElementIndex].zIndex - 1
                activePageElements[activeElementIndex - 1].zIndex = activePageElements[activeElementIndex - 1].zIndex + 1
            }
        }

        state.project.pages[state.currentPageIndex].content.elements = activePageElements.sort((a, b) => a.zIndex - b.zIndex)
    },
    updateAllElements(state, payload) {
        state.project.pages.forEach(page => {
            page.content.elements.map(el => {
                Object.keys(payload).forEach(item => {
                    el[item] = payload[item]
                })
            })
        })
    },
    saveProject (state) {
        localStorage.setItem('store', JSON.stringify(state));
    },
    setLoading (state, payload) {
        state.loading = payload;
    },
    setActiveThemeTab(state, payload) {
        state.activeThemeTab = payload;
    },
    setActiveProjectInThemeTab(state, payload) {
        state.activeProjectInThemeTab = payload;
    },
    setActiveFormatInThemeTab(state, payload) {
        state.activeFormatInThemeTab.id = payload.id;
        state.activeFormatInThemeTab.name = payload.name;
        state.activeFormatInThemeTab.width = payload.width;
        state.activeFormatInThemeTab.height = payload.height;
    },
    setTestToken(state, payload) {
        state.testToken = payload;
    },
    changePageTransition(state, payload) {
        if (payload.deleteAction !== undefined) {
            state.pageTransition = 0;
        } else {
            state.pageTransition = payload;
        }
    },
    hidePanelTab(state, payload) {
        state.hiddenTabs[payload.tabName] = payload.value;
    },
    addFormatedCustomFonts(state, payload) {
        JSON.parse(JSON.stringify(payload)).forEach(f => {
            state.fonts.push(f);
        })
    },
    allElementsLoaded(state) {
        state.allElementsLoaded = true;
    },
    elementsChanging(state, payload) {
        state.elementsChanging = payload;
    }
}